export const ALGOLIA_APP_ID = '8K6J5OJIQW';
export const ALGOLIA_APP_KEY = 'c982b4b1a6ca921131d35edb63359b8c';
export const PRODUCT_NAME_ID = 'partner-purchasing-center';
export const IN_PRODUCT_HELP_ROUTE_GROUP = 'ppc';
export const IN_PRODUCT_HELP_ROUTE_GROUP_NEW = 'ppc-new';

// Feedback related constants

// Jira Projects -
// 1.prod instance: https://customerfeedback.atlassian.net/browse/PPC
// 2.non-prod instance:  https://customerfeedback.atlassian.net/browse/PAFTC
// EPIC Page: https://hello.atlassian.net/wiki/spaces/COMITFO/pages/2534780743/Epic+Page+Feedback+Collector+in+PPC
export const PROD_ENTRYPOINT_ID = '30354de0-0d5d-4abd-9618-67532ec937e7';
export const NON_PROD_ENTRYPOINT_ID = '519bdb7e-d1a1-493e-8a93-2c71b76707f2';
export const SUMMARY_PLACEHOLDER_TEXT =
  'Tell us about your experience using Partner Purchasing Center so that we can make it even better.';
